module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont-d7c639.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 808
// module chunks = 2